const withConfig = WrappedComponent => {
    return function WithConfigComponent(props) {
        const config = window.$config
        
        return (
            <WrappedComponent config={config} {...props} />
        )
    }
}

export default withConfig
